import React from "react";
import PersonIcon from "../icons/PersonIcon";
import { Paths } from "../../../../Paths";
import OutsideClickHandler from "react-outside-click-handler";
import { useBoolean } from "../../../hooks/common/useBoolean";
import MailIcon from "../../common/icons/MailIcon";
import KeyIcon from "../../common/icons/KeyIcon";
import LogoutIcon from "../../common/icons/LogoutIcon";
import { useNavigate } from "react-router-dom";

export default function AccountButton() {

    const navigate = useNavigate();

    const [isOpen, , closeMenu, toggle] = useBoolean();

    const handleNotificationEmailClicked = () =>{
        navigate(Paths.notificationEmail);
        closeMenu();
    };

    const handleChangePasswordClicked = () => {
        navigate(`${Paths.changePassword}`);
        closeMenu();
    };

    const handleLogOutClicked = () => {
        window.location.href = Paths.logout;
        closeMenu();
    };

    const renderMenus = () => {
        if (!isOpen) return null;

        return (
            <div className={"drop_down__menus"}>
                <div className={"menu"} onClick={handleNotificationEmailClicked}>
                    <div className={"icon"}><MailIcon/></div>
                    通知先設定
                </div>
                <div className={"menu"} onClick={handleChangePasswordClicked}>
                    <div className={"icon"}><KeyIcon/></div>
                    パスワード変更
                </div>
                <div className={"menu"} onClick={handleLogOutClicked}>
                    <div className={"icon"}><LogoutIcon/></div>
                    ログアウト
                </div>
            </div>
        );
    };

    return (
        <OutsideClickHandler onOutsideClick={closeMenu}>
            <div className={"account_button"}>
                <button onClick={toggle} >
                    <PersonIcon/>
                    <div>アカウント</div>
                </button>
                {renderMenus()}
            </div>
        </OutsideClickHandler>
    );
}